import { z } from 'zod'

/**
 * Auth — magic link contracts.
 *
 * POST /auth/request { email } -> 202 (always, to prevent user enumeration)
 * GET  /auth/callback?token=...  -> JWT (either as JSON body or via redirect)
 *
 * Implementation lands in plan 01-02; this package only declares the shapes
 * so routes, clients and the JSON Schema dump stay in sync.
 */

export const RequestMagicLinkSchema = z.object({
  email: z.string().email().max(254),
})

export const AuthCallbackQuerySchema = z.object({
  token: z.string().min(16).max(256),
})

export const AuthCallbackResponseSchema = z.object({
  jwt: z.string().min(10),
  user: z.object({
    id: z.string(),
    email: z.string().email(),
  }),
})
